import Cookies from 'js-cookie'

import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'

export const SET_TAB_LAYERS_FILTER = 'SET_TAB_LAYERS_FILTER'
export const SET_TAB_LAYERS_FILTER_DISABLED = 'SET_TAB_LAYERS_FILTER_DISABLED'

export const setTabLayersFilter = tabLayersFilter => {
  return dispatch => {
    dispatch({
      type: SET_TAB_LAYERS_FILTER,
      tabLayersFilter
    })
    Model.setState('filter', null, tabLayersFilter)
    HistoryUpdate()
    Cookies.set('pozi-state-filter', JSON.stringify(tabLayersFilter))
  }
}

export const setTabLayersFilterDisabled = tabLayersFilterDisabled => {
  return dispatch => {
    dispatch({
      type: SET_TAB_LAYERS_FILTER_DISABLED,
      tabLayersFilterDisabled
    })
    if (tabLayersFilterDisabled) {
      Model.setState('filterdisabled', null, tabLayersFilterDisabled)
    } else {
      Model.unset('app.state.filterdisabled')
    }
    HistoryUpdate()
  }
}
